<template>
  <v-dialog v-model="dialog" max-width="500px">
    <template v-slot:activator="{ props }">
      <v-btn color="primary" dark class="mb-2" v-bind="props">{{ $t('meta.addGenre') }}</v-btn>
    </template>
    <v-card>
      <v-card-title>
        <span class="text-h5">{{ $t('meta.addNewGenre') }}</span>
      </v-card-title>
      <v-card-text>
        <v-form @submit.prevent="addGenre" ref="form">
          <v-text-field v-model="genre.name" :label="$t('meta.name')" required></v-text-field>
          <v-text-field v-model="genre.genre_index" :label="$t('meta.index')" type="number" required></v-text-field>
          <v-text-field v-model="genre.code" :label="$t('meta.code')" required></v-text-field>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="dialog = false">{{ $t('meta.cancel') }}</v-btn>
        <v-btn color="blue darken-1" text @click="addGenre">{{ $t('meta.add') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup>
import { ref } from 'vue'
import axios from 'axios'
import { useI18n } from 'vue-i18n'

const { t: $t } = useI18n()

const emit = defineEmits(['genre-added'])

const dialog = ref(false)
const genre = ref({
  name: '',
  genre_index: null,
  code: ''
})

async function addGenre() {
  try {
    await axios.post('/api/genres', genre.value)
    emit('genre-added')
    dialog.value = false
    genre.value = {
      name: '',
      genre_index: null,
      code: ''
    }
  } catch (error) {
    console.error('Error adding genre:', error)
  }
}
</script>
